
<main *ngIf="bShowTemplate" class="">

    <!-- عنوان اصلی صفحه -->

    <!-- فرم ثبت نام و ورود -->

    <article class="header-taxilon px-3 mb-5 w-100 h-100 p-2" #point_1>

        <div class="background-image position-relative w-100 h-100">

            <img width="100%" src="../../assets/imgs/partner-bg.png" alt="همکاران امدادران">

            <div class="header-layer w-100 h-100">

                <div class="signUp-container px-4 pb-3">

                    <h2 class="text-center border-bottom border-3">

                        <ng-container *ngIf="!mdl_Login.get('bOTP')?.value;else title_OTP">

                            {{ mdl_Login.get('bRegister')?.value ? 'ثبت نام همکاران' : 'ورود به حساب ' }}

                        </ng-container>

                        <ng-template #title_OTP>

                            تایید کد 

                        </ng-template>

                    </h2>

                    <div [formGroup]="mdl_Login" class="row gx-0 gy-3">

                        <ng-container *ngIf="!mdl_Login.get('bOTP')?.value;else mdl_OTP">

                            <!-- شماره موبایل -->

                            <div class="col-12 form-group has-icon">

                                <span class="form-control-icon">
        
                                    <mat-icon class="mat-18">phone_iphone</mat-icon>
        
                                </span>
        
                                <input class="w-100 form-control" #strMobile

                                    autocomplete="mobile"

                                    [ngStyle]="{ direction: strMobile.value.trim() == '' ? 'rtl' : 'ltr' }"

                                    [placeholder]="strMobile.value.trim() == '' ? ' * شماره موبایل ' : '' "

                                    (input)="filterNumericInput($event)" inputmode="numeric"
                                    
                                    maxlength="11" formControlName="strMobile" type="text">
        
                            </div>

                            <!-- نام و نام خانوادگی -->

                            <ng-container *ngIf="mdl_Login.get('bRegister')?.value">

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">
            
                                        <mat-icon class="mat-18">badge</mat-icon>
            
                                    </span>
            
                                    <input class="w-100 form-control" 
                                    
                                        placeholder="* نام و نام خانوادگی"

                                        formControlName="strFullName"
                                        
                                        type="text" autocomplete="cc-family-name">
            
                                </div>

                            </ng-container>

                            <!-- رمز عبور -->

                            <div class="col-12 form-group has-icon">

                                <span class="form-control-icon">

                                    <mat-icon class="mat-18"> lock </mat-icon>

                                </span>

                                <input type="password" class="w-100 form-control" formControlName="strUserPassword"
                                
                                    placeholder="* رمز عبور" autocomplete="new-password">

                            </div>

                            <!-- فیلد های ثبت نام -->

                            <ng-container *ngIf="mdl_Login.get('bRegister')?.value">

                                <!-- تکرار رمز عبور -->

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">

                                        <mat-icon class="mat-18"> lock </mat-icon>

                                    </span>

                                    <input type="password" class="w-100 form-control" formControlName="_strUserPassword"
                                    
                                        placeholder="* تکرار رمز عبور" autocomplete="new-password">

                                </div>

                                <!-- آدرس -->

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">
            
                                        <mat-icon class="mat-18">home_app_logo</mat-icon>
            
                                    </span>
            
                                    <input class="w-100 form-control" placeholder=" آدرس" formControlName="strAddress"
                                    
                                        type="text" autocomplete="address-level1">
            
                                </div>

                                <!-- نام شرکت  -->

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">
            
                                        <mat-icon class="mat-18">apartment</mat-icon>
            
                                    </span>
            
                                    <input class="w-100 form-control" placeholder=" نام شرکت " formControlName="strCompanyName"
                                    
                                        type="text" autocomplete="cc-additional-name">
            
                                </div>

                            </ng-container>

                        </ng-container>

                        <ng-template #mdl_OTP>

                            <p class="hint-otp my-2 text-dark"> 

                                کد ارسال شده به شماره 

                                <span> {{ mdl_Login.get('strMobile')?.value | faNum }} </span>

                                را وارد کنید.
                                
                            </p>

                            <div class="otp-input">

                                <input type="number" (input)="enforceMaxLength($event,'1')" id="input1" required>

                                <input type="number" (input)="enforceMaxLength($event,'2')" id="input2" required>

                                <input type="number" (input)="enforceMaxLength($event,'3')" id="input3" required>

                                <input type="number" (input)="enforceMaxLength($event,'4')" id="input4" required>

                            </div>

                        </ng-template>

                        <!-- تایید -->

                        <div class="col-12 pt-2">

                            <button type="button" class="btn btn-primary w-100" (click)="submit_form()"> 

                                تایید

                            </button>

                        </div>

                        <!-- حساب کاربری دارید؟ -->

                        <div class="row gx-0 gy-0 pt-2 justify-content-center col-12 mt-3 border-top border-3">

                            <!-- حساب کاربری دارید ؟ -->

                            <div class="col-5 text-center py-2 pointer" (click)="mdl_Switch()">

                                <ng-container *ngIf="!mdl_Login.get('bOTP')?.value;else back_OTP">

                                    <span class="text-dark">

                                        {{ mdl_Login.get('bRegister')?.value ? 'حساب کاربری دارید ؟' : 'ثبت نام نکرده اید؟' }}


                                    </span>

                                </ng-container>

                                <ng-template #back_OTP>

                                    <span class="text-dark"> بازگشت </span>

                                </ng-template>

                            </div>

                            <div class="col-auto text-center py-2">

                                <span class="text-dark">|</span>

                            </div>

                            <div class="col-5 text-center py-2 pointer" (click)="mdl_Login.get('bRegister')?.value ? openAdd() : reset_Password() ">

                                <span class="text-dark">

                                    {{ mdl_Login.get('bRegister')?.value || mdl_Login.get('bOTP')?.value ? 'قوانین و مقررات' : 'فراموشی رمز عبور' }}

                                </span>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
        
        <div class="my-5 d-flex flex-column justify-content-center align-items-center">

            <div class="img-container text-center">

                <img width="128px" src="../../assets/imgs/dashboard.png" alt="پنل اختصاصی شرکت‌های همکار در امدادران">
    
            </div>

            <h2 class="fw-bold mt-3" style="font-size: 25px;line-height: 40px;"> پنل اختصاصی شرکت‌های همکار در امدادران! </h2>

            <div class="title-header w-100" style="padding: 0 120px;">
    
                <p class="m-0 fw- text-muted text-center" style="font-size:16px;line-height: 40px;">
                    
                    امدادران با ارائه یک پنل اختصاصی برای شرکت‌های همکار، فرصتی بی‌نظیر را فراهم کرده است تا بدون نیاز به تهیه نرم‌افزار یا زیرساخت جداگانه، خدمات حمل خودرو را به مشتریان خود ارائه دهند.                      
                </p>
    
            </div>

        </div>

    </article>

    <!-- ویژگی‌های پنل شرکت‌های همکار -->

    <article class="d-flex flex-column align-items-center px-3 pt-3 w-100 h-100" style="background: #f5f5f5;">

        <h2 class="fw-bold mt-3" style="line-height: 40px;">ویژگی‌های پنل شرکت‌های همکار</h2>

        <div class="container w-100 row gx-0 gy-5 mb-5 p-4">

            <!-- مدیریت ساده درخواست‌ها  -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/panel.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> مدیریت ساده درخواست‌ها  </strong>
    
                        <small class="fw-bold text-muted"> تمامی درخواست‌های مشتریان خود را در پنل ثبت و مدیریت کنید. </small>
    
                    </div>

                </div>
                


            </div>
                     
            <!-- بدون نیاز به استخدام راننده -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/no-car.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> بدون نیاز به استخدام راننده </strong>
    
                        <small class="fw-bold text-muted"> تمامی خدمات توسط شبکه حرفه‌ای رانندگان امدادران انجام می‌شود.  </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- پشتیبانی حرفه‌ای -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/24-hours-support.png" alt="پشتیبانی حرفه‌ای">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> پشتیبانی حرفه‌ای</strong>
    
                        <small class="fw-bold text-muted"> تیم پشتیبانی ما در تمام مراحل کنار شماست تا به سوالات و مشکلات شما پاسخ دهد. </small>
    
                    </div>

                </div>
                
            </div>
            
            <!-- کمیسیون تضمین‌شده -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/taxes.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> کمیسیون تضمین‌شده </strong>
    
                        <small class="fw-bold text-muted"> کمیسیون خود را به‌صورت شفاف و منظم دریافت کنید. </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- صرفه‌جویی در هزینه‌ها -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/reduce-cost.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> صرفه‌جویی در هزینه‌ها </strong>
    
                        <small class="fw-bold text-muted"> با استفاده از پنل امدادران، دیگر نیازی به تهیه نرم‌افزار یا ایجاد زیرساخت جداگانه ندارید.  </small>
    
                    </div>

                </div>
                


            </div>
               

        </div>

    </article>

    <!-- چرا پنل امدادران؟ -->

    <article class="d-flex flex-column align-items-center px-3 pt-3 w-100 h-100">

        <div class="my-5 d-flex flex-column justify-content-center align-items-center">

            <div class="img-container text-center">

                <img width="128px" src="../../assets/imgs/question.png" alt="چرا پنل امدادران">
    
            </div>

            <h2 class="fw-bold mt-3" style="font-size: 25px;line-height: 40px;"> چرا پنل امدادران؟! </h2>

            <div class="title-header w-100" style="padding: 0 120px;">
    
                <p class="m-0 fw- text-muted text-center" style="font-size:16px;line-height: 40px;">
                    
                    با استفاده از پنل شرکت‌های همکار امدادران، شما می‌توانید خدمات حمل خودرو را به سبد خدمات خود اضافه کنید و بدون دغدغه مدیریت عملیات، رضایت مشتریان خود را افزایش دهید.  

                    همین امروز به شبکه شرکت‌های همکار امدادران بپیوندید و کسب‌وکار خود را گسترش دهید!

                                        
                </p>

                <div class="w-100 d-flex justify-content-center mt-4">

                    <button class="btn btn-success" (click)="gotoTop()"> ثبت نام در پنل همکاران </button>

                </div>
    
            </div>

        </div>

    </article>
    
    <!-- سوالات رایج -->

    <article dir="rtl" class="faq-taxilon container p-2 my-5" >

        <div class="accordion" id="accordionExample">

            <div class="accordion-item">

              <h1 class="accordion-header" id="headingOne">

                <button class="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">

                    آیا استفاده از پنل امدادران هزینه دارد؟

                </button>

              </h1>

              <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">

                <div class="accordion-body">

                    خیر، ثبت‌نام و استفاده از پنل کاملاً رایگان است. شما فقط از سفرهایی که ثبت می‌کنید کمیسیون دریافت می‌کنید.

                </div>

              </div>

            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    کمیسیون به چه صورتی محاسبه می‌شود؟
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    درصدی از هزینه هر خدمت به حساب شما تعلق می‌گیرد و گزارش آن در پنل شما نمایش داده می‌شود.                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    آیا متقاضیان از کیفیت خدمات راضی خواهند بود؟
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    بله، رانندگان امدادران حرفه‌ای هستند و خودروها کاملاً استاندارد و ایمن هستند.

                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFour">
                <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    چگونه مطمئن شوم خودروها به موقع اعزام می‌شوند؟
                </button>
              </h2>
              <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    سیستم ما به صورت خودکار نزدیک‌ترین راننده موجود را انتخاب و هماهنگی‌ها را انجام می‌دهد.
                </div>
              </div>
            </div>

        </div>

    </article>

</main>

<!--  -->

<app-footer></app-footer>